import { useCallback, useRef } from "react";
import { pdfGenerator } from "../services/pdf";
import { usePumpRecommendationContext } from "../context/PumpRecommendationContext";
import useResponsive from "./useResponsive";

export function usePDFGeneration() {
  const { formData, recommendations } = usePumpRecommendationContext();
  const graphRef = useRef<HTMLDivElement>(null);
  const { isSm, isXs } = useResponsive();
  const isMobile = isSm || isXs;

  const generatePDF = useCallback(
    async (download = true) => {
      if (!formData) {
        console.error("Form data is required for PDF generation");
        return;
      }

      try {
        
        const userData = {
          user: formData.user || "User",
          email: formData.email || "user@example.com",
          isExistingPool: formData.isExistingPool || false,
          latestRecommendationReportId: undefined, 
        };

        await pdfGenerator.generatePDF({
          download,
          isEmpty:
            !recommendations ||
            (recommendations.standard.capacity === 0 &&
              recommendations.premium.capacity === 0),
          graphRef,
          formData,
          recommendations,
          isMobile,
          ...userData,
        });
      } catch (error) {
        console.error("Failed to generate PDF:", error);
        
      }
    },
    [formData, recommendations, isMobile]
  );

  return {
    generatePDF,
    graphRef,
  };
}
